import { clone, toString } from "./utils";
export function handlesValidationForField(input) {
    return ['group', 'map', 'list', 'single'].includes(input.fieldType);
}
export function createFormFieldState(formField, definition) {
    const key = formField.name;
    if (definition.value[key] === undefined && formField.fieldType !== 'split') {
        definition.value[key] = formField.valueWhenMissing;
    }
    const initialValue = (definition.initialValue[key] === undefined && formField.fieldType !== 'split')
        ? formField.valueWhenMissing
        : definition.initialValue[key];
    return {
        form: formField,
        value: definition.value[key],
        initialValue,
        internalState: definition.internalState[key],
        validationErrors: definition.validationErrors[key],
    };
}
export function toChildState(formField, state) {
    const key = formField.name;
    let value = (state === null || state === void 0 ? void 0 : state.value) ? state === null || state === void 0 ? void 0 : state.value[key] : undefined;
    if (value === undefined) {
        value = null;
        if (formField.fieldType !== 'split') {
            value = formField.valueWhenMissing;
        }
    }
    let initialValue = (state === null || state === void 0 ? void 0 : state.initialValue) ? state === null || state === void 0 ? void 0 : state.initialValue[key] : undefined;
    if (initialValue === undefined) {
        initialValue = null;
        if (formField.fieldType !== 'split') {
            initialValue = formField.valueWhenMissing;
        }
    }
    return {
        form: formField,
        value,
        initialValue,
        internalState: state.internalState ? state.internalState[key] : null,
        validationErrors: state.validationErrors ? state.validationErrors[key] : null,
    };
}
export function hasInputOptionValue(state, value) {
    if (Array.isArray(state.additionalSettings.options)) {
        for (let option of state.additionalSettings.options) {
            if (option.value === value) {
                return true;
            }
        }
    }
    return false;
}
export function changeForm(formField, state) {
    state = clone(state);
    state.form = formField;
    return state;
}
const FORM_FIELDS = [
    'apie-form-field-definition',
    'apie-form-group-definition',
    'apie-form-list-definition',
    'apie-form-map-definition',
    'apie-form-select-definition',
];
export async function toFormField(list) {
    const fields = [];
    await Promise.all(Array.from(list).map(async (childNode) => {
        if (FORM_FIELDS.indexOf(String(childNode.nodeName).toLowerCase()) > -1 && !childNode.prototyped) {
            fields.push(await childNode.getDefinition());
            return childNode;
        }
        return null;
    }));
    return fields;
}
export async function getFormConstraints(el) {
    const promises = [];
    for (let childNode of el.childNodes) {
        if (String(childNode.nodeName).toLowerCase() === 'apie-constraint-check-definition') {
            promises.push(childNode.getDefinition());
        }
    }
    return Promise.all(promises);
}
export function isValid(value, constraint) {
    const result = constraint.inverseCheck ? (r) => !r : (r) => r;
    let exactMatch = constraint.exactMatch === value
        || (constraint.exactMatch === '' && value === null)
        || (constraint.exactMatch === null && value === '');
    if (constraint.exactMatch !== undefined && result(exactMatch)) {
        return false;
    }
    value = toString(value);
    if (constraint.maxLength !== undefined && result(value.length > constraint.maxLength)) {
        return false;
    }
    if (constraint.minLength !== undefined && result(value.length < constraint.minLength)) {
        return false;
    }
    if (constraint.pattern !== undefined && !result((new RegExp(constraint.pattern)).test(value))) {
        return false;
    }
    return true;
}
export function validate(value, constraints) {
    const result = {
        valid: true,
        messages: []
    };
    for (let constraint of constraints) {
        let constraintIsValid = isValid(value, constraint);
        if (!constraintIsValid) {
            result.valid = false;
        }
        if (constraint.message !== undefined) {
            result.messages.push({
                valid: constraintIsValid,
                message: constraint.message,
                serverSide: constraint.serverSide,
            });
        }
    }
    return result;
}
//# sourceMappingURL=FormDefinition.js.map
